export enum TravelType {
    ROUND_TRIP,
    ONE_WAY,
    NO_FLIGHT,
}
